import { saveProductListClick, loadProductListClick } from '@ts/utils/cs';
import { Product, ProductInList, ProductDetail, ProductCartItem } from '../types';
import { CURRENCY } from '../variables';
import { Analytics } from '..';

export default function product(self: Analytics) {
    return {
        click(
            payload: Product | Product[] | ProductInList | ProductInList[],
            listName: string = ''
        ) {
            const products = Array.isArray(payload) ? payload : [payload];
            if (products.length <= 0) {
                return self;
            }

            self.dataLayer({
                event: 'productClick',
                ecommerce: {
                    click: {
                        actionField: { action: 'click', list: listName },
                        products,
                    },
                },
            });

            const lastItem = products[products.length - 1];

            if (lastItem && lastItem.id && listName) {
                saveProductListClick([lastItem.id, listName].join('|'));
            }

            return self;
        },

        clickCheckAvailability(payload: Product | Product[]) {
            const products = Array.isArray(payload) ? payload : [payload];

            if (products.length <= 0) {
                return self;
            }

            self.DataLayerEvent({
                action: 'Clicked Check',
                category: 'Activity Availability',
                label: 'Button',
                nonInteraction: false,
            });

            self.dataLayer({
                event: 'productClickCheckAvailability',
                products,
            });

            return self;
        },

        selectAvailabilityDates(
            payload: Product | Product[],
            { startDate, endDate }: { startDate: string; endDate?: string }
        ) {
            const products = Array.isArray(payload) ? payload : [payload];

            if (products.length <= 0) {
                return self;
            }

            self.DataLayerEvent({
                category: 'Activity Availability',
                action: 'Select Dates',
                label: [startDate, endDate].filter(Boolean).join(' ~ '),
                nonInteraction: false,
            });

            self.dataLayer({ event: 'productSelectAvailabilityDates', products });

            return self;
        },

        selectAvailabilityDay(payload: Product | Product[], { dayDate }: { dayDate: string }) {
            const products = Array.isArray(payload) ? payload : [payload];

            if (products.length <= 0) {
                return self;
            }

            self.DataLayerEvent({
                category: 'Activity Availability',
                action: 'Select Day',
                label: dayDate,
                nonInteraction: false,
            });

            self.dataLayer({ event: 'productSelectAvailabilityDay', products });

            return self;
        },

        detail(payload: ProductDetail | ProductDetail[], listName: string = '') {
            const products = Array.isArray(payload) ? payload : [payload];

            if (products.length <= 0) {
                return self;
            }

            const getListName = () => {
                if (listName) {
                    return listName;
                }

                const [id, ...rest] = loadProductListClick().split('|');
                const storedListNames: { [key: string]: string } =
                    (id && rest && rest.length > 0 && { [id]: rest.join('|') }) || {};

                const namedProduct = products.find((product) => !!storedListNames[product.id]);
                return (namedProduct && storedListNames[namedProduct.id]) || '';
            };

            self.dataLayer({
                ecommerce: {
                    detail: {
                        actionField: { action: 'detail', list: getListName() },
                        products,
                    },
                },
                event: 'productDetail',
            });

            products.forEach((product) => {
                self.fbq('track', 'ViewContent', {
                    content_ids: product.id,
                    content_category: product.category,
                    content_name: product.name,
                    content_type: 'product',
                    product_catalog_id: 333969174115095,
                });
            });

            return self;
        },

        addToCart(payload: ProductCartItem | ProductCartItem[]) {
            const products = Array.isArray(payload) ? payload : [payload];

            if (products.length <= 0) {
                return self;
            }

            self.dataLayer({
                event: 'addToCart',
                ecommerce: {
                    add: {
                        products,
                    },
                },
            });

            products.forEach((product) => {
                self.fbq('track', 'AddToCart', {
                    value: product.price,
                    currency: CURRENCY,
                    content_name: product.name,
                    content_type: 'product',
                    product_catalog_id: 333969174115095,
                    content_ids: product.id,
                });
            });

            return self;
        },

        viewCart(payload: ProductCartItem | ProductCartItem[]) {
            const products = Array.isArray(payload) ? payload : [payload];

            if (products.length <= 0) {
                return self;
            }

            self.dataLayer({
                event: 'productViewCart',
                ecommerce: {
                    detail: {
                        products,
                    },
                },
            });

            return self;
        },
    };
}
